'use strict';

module Patersons {
    export class SensitiveAddressChangeRequestCtrl extends TwoFactorAuthenticationCtrl {
        portfolioService: PortfolioService;
        accountId: string;
        address: Address;

        static $inject = ['$scope', '$uibModalInstance', 'identityService', 'portfolioService', 'account', 'address'];

        constructor($scope, $uibModalInstance, identityService, portfolioService, account, address) {
            super($scope, $uibModalInstance, identityService)

            this.portfolioService = portfolioService;

            this.accountId = account.accountId;
            this.address = address;
            this.scope.nameOfPdf = "Change of Account Details"
            this.scope.linkToPdf = "https://www.canaccordgenuity.com/4a460f/globalassets/wealth-management-australia/documents/forms/change-of-address-details-form";
        }

        submit() {
            this.scope.isSubmitted = true;

            if (this.scope.twoFactorAuthForm.$invalid) {
                return;
            }

            this.scope.isBusy = true;
            this.address.smsToken = this.scope.verificationCode;

            this.portfolioService.updateRegistrationAddressDetails(this.accountId, this.address)
                .then((result) => {
                    this.modalInstance.close(true);
                },
                (reason) => {
                    this.handleErrorResponse(reason);
                })
                .finally(() => {
                    this.scope.isBusy = false;
                });
        }
    }
}
